<template>
  <div>
    <div class="debugger" @click="onIconClick">
      <m-icon type="setting" />
    </div>
    <m-popup v-model:visible="visible" position="right" width="80%">
      <div class="debugger-content">
        <div class="debugger-content-count">
          <div>
            接口请求
            <m-text type="success">{{ requestCount }}</m-text>
            个， 灰度
            <m-text type="success">{{ requestGrayCount }}</m-text>
            个， 线上
            <m-text type="success">{{ requestReleaseCount }}</m-text>
            个
          </div>
          <div>
            静态资源
            <m-text type="success">{{ assestCount }}</m-text>
            个， 灰度
            <m-text type="success">{{ assestGrayCount }}</m-text>
            个， 线上
            <m-text type="success">{{ assestReleaseCount }}</m-text>
            个
          </div>
        </div>

        <m-tabs>
          <m-tab title="接口请求" class="debugger-content-tab">
            <m-list>
              <m-list-item v-for="(item, index) in response" :key="index">
                <m-row>
                  <m-col :span="8">系统</m-col>
                  <m-col :span="16">{{ item.type }}</m-col>
                  <m-col :span="8">kong转发</m-col>
                  <m-col :span="16">
                    <m-text :type="item.isKong ? 'success' : 'datk'">
                      {{ item.isKong ? "是" : "否" }}
                    </m-text>
                  </m-col>
                  <m-col :span="8">环境</m-col>
                  <m-col :span="16">
                    <m-text :type="item.isGray ? 'dark' : 'success'">
                      {{ item.isGray ? "灰度环境" : "线上环境" }}
                    </m-text>
                  </m-col>
                  <m-col :span="8">请求地址</m-col>
                  <m-col :span="16">
                    {{ item.url }}
                  </m-col>
                </m-row>
              </m-list-item>
            </m-list>
          </m-tab>
          <m-tab title="静态资源" class="debugger-content-tab">
            <m-list>
              <m-list-item v-for="(item, index) in assest" :key="index">
                <m-row>
                  <m-col :span="8">环境</m-col>
                  <m-col :span="16">
                    <m-text :type="item.isGray ? 'dark' : 'success'">
                      {{ item.isGray ? "灰度环境" : "线上环境" }}
                    </m-text>
                  </m-col>
                  <m-col :span="8">类型</m-col>
                  <m-col :span="16">
                    <m-col :span="16">{{ item.type }}</m-col>
                  </m-col>
                  <m-col :span="8">请求地址</m-col>
                  <m-col :span="16">
                    {{ item.url }}
                  </m-col>
                </m-row>
              </m-list-item>
            </m-list>
          </m-tab>
        </m-tabs>
        <m-button type="primary" full @click="onButtonClick">退出调试</m-button>
      </div>
    </m-popup>
  </div>
</template>

<script lang="ts">
import { useGrayService } from "@nebula/gray";
import { computed, defineComponent, PropType, ref } from "vue";

type Model = { isGray: boolean };

export default defineComponent({
  props: {
    assest: {
      type: Array as PropType<Array<Model>>,
      default: () => [],
    },
    response: {
      type: Array as PropType<Array<Model>>,
      default: () => [],
    },
  },
  setup(props) {
    const visible = ref(false);

    const onIconClick = () => {
      visible.value = true;
    };

    const requestCount = computed(() => {
      return props.response.length;
    });

    const requestGrayCount = computed(() => {
      return props.response.filter((r) => r.isGray).length;
    });
    const requestReleaseCount = computed(() => {
      return props.response.filter((r) => !r.isGray).length;
    });
    const assestCount = computed(() => {
      return props.assest.length;
    });
    const assestGrayCount = computed(() => {
      return props.assest.filter((r) => r.isGray).length;
    });
    const assestReleaseCount = computed(() => {
      return props.assest.filter((r) => !r.isGray).length;
    });

    const onButtonClick = () => {
      useGrayService().debug = false;
    };

    return {
      visible,
      onIconClick,
      requestCount,
      requestGrayCount,
      requestReleaseCount,
      assestCount,
      assestGrayCount,
      assestReleaseCount,
      onButtonClick,
    };
  },
});
</script>

<style lang="scss" scoped>
.debugger {
  position: fixed;
  right: 20px;
  bottom: 20px;
  font-size: 32px;
  color: $--color-text--secondary;
  z-index: 9999;
  cursor: pointer;
}

.debugger-content-count {
  background: #ffffff;
  padding: 16px;
  margin-bottom: 10px;
}

.debugger-content {
  width: 100%;
  height: 100%;
  background: #f2f2f2;
  overflow: auto;
}

.debugger-content-tab {
  margin-top: 10px;
}

.m-col {
  word-break: break-all;
  padding-bottom: 8px;
}

.m-button {
  margin: 12px 0;
}
</style>
